import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Grid, Card, Item} from 'semantic-ui-react';
import _ from 'lodash';

const renderHeader = (header) => (
  <Card.Header>
    <b>{header}</b>
  </Card.Header>
);

const getPhoneNumber = (phoneNumber, extension) => {
  if (extension) {
    return `${phoneNumber} ext.${extension}`;
  }
  return phoneNumber;
};

const checkAorChange = (amendments) => {
  let aorChange = false;
  
  if(amendments != undefined){
    Object.keys(amendments).forEach(key => {
      const amendmentStatus = _.get(amendments[key], 'status');
      const amendmentChangeTypes = _.get(amendments[key], 'payload.review.changeTypes.aor');
      
      if(amendmentStatus === 'approved' && amendmentChangeTypes === true){
        aorChange = true;
      }
    })
  }
  return aorChange;
}


const getAorPhoneNumber = (areaCode, phoneNumber, extension) => {
  if (extension && !_.isEmpty(extension)) {
    return `${areaCode}${phoneNumber} ext.${extension}`;
  }
  return areaCode + phoneNumber;
};

const renderContact = (header, contact, emailLabel) => {
  const name = `${_.get(contact, 'firstName', '')} ${_.get(contact, 'lastName', '')}`;
  const contactData = [
    `Name: ${name.trim() || 'N/A'}`,
    `Title: ${_.get(contact, 'title', 'N/A')}`,
    `${emailLabel}: ${_.get(contact, 'email', 'N/A')}`,
    `Primary phone: ${getPhoneNumber(
      _.get(contact, 'phoneNumber', 'N/A'),
      _.get(contact, 'extension')
    )}`,
    `Secondary phone: ${getPhoneNumber(
      _.get(contact, 'secondaryPhoneNumber', 'N/A'),
      _.get(contact, 'secondaryPhoneExt')
    )}`,
  ];
  return (
    <Grid.Column>
      {renderHeader(header)}
      {_.map(contactData, (dat, i) => (
        <Card.Content key={i}>{dat}</Card.Content>
      ))}
    </Grid.Column>
  );
};

const renderAorContact = (header, contact, emailLabel) => {
  
  const contactAorData = [
    `Name: ${_.get(contact, 'firstName')} ${_.get(contact, 'lastName')}`,
    `Title: ${'N/A'}`,
    `${emailLabel}: ${_.get(contact, 'emailAdr')}`,
    `Primary phone: ${getAorPhoneNumber(
      _.get(contact, 'phoneNumbers[0].areaCode', ''),
      _.get(contact, 'phoneNumbers[0].phoneNumber', ''),
      _.get(contact, 'phoneNumbers[0].phoneExtension', '')
    )}`,
    `Secondary phone: ${getAorPhoneNumber(
      _.get(contact, 'phoneNumbers[1].areaCode', ''),
      _.get(contact, 'phoneNumbers[1].phoneNumber', 'N/A'),
      _.get(contact, 'phoneNumbers[1].phoneExtension', '')
    )}`

   ];
  return (
    <Grid.Column>
      {renderHeader(header)}
      {_.map(contactAorData, (data, i) => (
        <Card.Content key={i}>{data}</Card.Content>
      ))}
    </Grid.Column>
  );
};

const renderGrantWriter = (appContactInfo, emailLabel) => {
  if (_.get(appContactInfo, 'hasPreparer', false)) {
    return _.map(_.get(appContactInfo, 'participants'), (contact, ind) => {
      const contactData = [
        `Preparer's name: ${_.get(contact, 'firstName')} ${_.get(contact, 'lastName')}`,
        `${emailLabel}: ${_.get(contact, 'email')}`,
        `Primary phone: ${getPhoneNumber(
          _.get(contact, 'phoneNumber'),
          _.get(contact, 'extension')
        )}`,
        `Address: ${_.get(contact, 'mailingAddress.address1')}`,
        _.get(contact, 'mailingAddress.address2'),
        _.get(contact, 'mailingAddress.city'),
      ];

      return (
        <Grid.Column key={ind}>
          {renderHeader('Grant writer')}
          {_.map(contactData, (dat, i) => (
            <Card.Content key={i}>{dat}</Card.Content>
          ))}
        </Grid.Column>
      );
    });
  }
  return null;
};

export class ContactsCard extends React.Component {
  render() {
    const {orgName, appContactInfo, grantAorContactInfo, grantContactInfo, amendments} = this.props;
    const toggles = _.get(this.props, "context.toggles.toggles", []);
    const emailLabel = _.includes(toggles, 'loginGovIntegration') ? "Email for notification" : "Email";

    return (
      <React.Fragment>
        <Grid columns={2}>
          <Item>
            <Item.Content>
              <b>Recipient Organization:</b> {orgName}
            </Item.Content>
          </Item>
          <Grid.Row>
          {checkAorChange(amendments) ? 
          renderAorContact(
              'Grant point of contact',
                grantAorContactInfo,
                emailLabel
                ) : (
                  renderContact(
                    'Grant point of contact',
                    _.find(grantContactInfo, (cont) => cont.type === 'primary'),
                    emailLabel
                )
            )}
            {renderContact(
              'Alternate contact 1',
              _.find(grantContactInfo, (cont) => _.get(cont, 'type') === 'alternate'),
              emailLabel
            )}
          </Grid.Row>
          <Grid.Row>{renderGrantWriter(appContactInfo, emailLabel)}</Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default connectDynamic(ContactsCard);
